const categories = [
  {
    title: 'Informática',
    icon: 'far fa-keyboard',
    params: { pathname: '/busca', state: { searchedCategory: 'informatica' } }
  },
  {
    title: 'Decoração',
    icon: 'fas fa-air-freshener',
    params: { pathname: '/busca', state: { searchedCategory: 'decoracao' } }
  },
  {
    title: 'Brinquedos',
    icon: 'fas fa-chess-knight',
    params: { pathname: '/busca', state: { searchedCategory: 'brinquedos' } }
  },
  {
    title: 'Bebês',
    icon: 'fas fa-baby-carriage',
    params: { pathname: '/busca', state: { searchedCategory: 'bebes' } }
  },
  {
    title: 'Ferramentas',
    icon: 'fas fa-tools',
    params: { pathname: '/busca', state: { searchedCategory: 'ferramentas' } }
  },
  {
    title: 'Moda',
    icon: 'fas fa-tshirt',
    params: { pathname: '/busca', state: { searchedCategory: 'moda' } }
  },
  {
    title: 'Pet',
    icon: 'fas fa-bone',
    params: { pathname: '/busca', state: { searchedCategory: 'pet' } }
  },
  {
    title: 'Beleza',
    icon: 'fas fa-cut',
    params: { pathname: '/busca', state: { searchedCategory: 'Beleza' } }
  },
  {
    title: 'Fitness',
    icon: 'fas fa-bicycle',
    params: { pathname: '/busca', state: { searchedCategory: 'fitness' } }
  },
  {
    title: 'Games',
    icon: 'fas fa-gamepad',
    params: { pathname: '/busca', state: { searchedCategory: 'games' } }
  },
  {
    title: 'Ver Todas',
    icon: 'fas fa-th-large',
    params: { pathname: '/busca', state: { searchedCategory: 'todas' } }
  }
];

export const getPathByParam = (params) => `/busca?category=${params.state.searchedCategory}`;
export default categories;
